<script lang="ts">
  let className: string = "";
  export let height: string = "h-[0.5px]";
  export let bgColor = "bg-black/12 dark:bg-white/10";
  export { className as class };
</script>

<div class="{height} rounded-lg {className} {bgColor}" aria-hidden="true" />
